export default __webpack_public_path__ + "static/bg_map_mobile-68492bb0c4b29c45f9dcc167e22d1f96.png";